import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export function Eyebrow({ children, testid }) {
  return (
    <span data-testid={testid} className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-cyan-400/90 mb-4">
      <span className="w-6 h-px bg-cyan-400/60" />
      {children}
    </span>
  );
}

export function SectionTitle({ children, className = "" }) {
  return (
    <h2 className={`font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl text-white ${className}`}>
      {children}
    </h2>
  );
}

export function PageHero({ eyebrow, title, subtitle, children }) {
  return (
    <section className="relative overflow-hidden grid-bg">
      <div className="aura w-[500px] h-[500px] bg-violet-700/20 -top-40 -left-20" />
      <div className="aura w-[400px] h-[400px] bg-cyan-600/20 top-0 right-0" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-24 pb-16">
        <Reveal>
          {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
          <h1 className="font-display font-bold tracking-tighter text-4xl md:text-5xl lg:text-6xl text-white max-w-4xl leading-[1.05]">
            {title}
          </h1>
          {subtitle && <p className="mt-6 text-lg text-zinc-400 max-w-2xl leading-relaxed">{subtitle}</p>}
          {children}
        </Reveal>
      </div>
    </section>
  );
}

export function GhostLink({ to, children, testid }) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className="group inline-flex items-center gap-2 text-white font-semibold hover:text-cyan-400 transition-colors duration-300"
    >
      {children}
      <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
    </Link>
  );
}

export function PrimaryButton({ to, onClick, children, testid, className = "", type = "button" }) {
  const cls = `group inline-flex items-center justify-center gap-2 bg-brand-gradient text-white font-semibold px-6 py-3 rounded-full hover:opacity-90 transition-opacity duration-300 ${className}`;
  if (to) return <Link to={to} data-testid={testid} className={cls}>{children}<ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" /></Link>;
  return <button type={type} onClick={onClick} data-testid={testid} className={cls}>{children}</button>;
}

export function SecondaryButton({ to, onClick, children, testid, className = "" }) {
  const cls = `inline-flex items-center justify-center gap-2 glass text-white font-semibold px-6 py-3 rounded-full hover:bg-white/10 transition-colors duration-300 ${className}`;
  if (to) return <Link to={to} data-testid={testid} className={cls}>{children}</Link>;
  return <button onClick={onClick} data-testid={testid} className={cls}>{children}</button>;
}
